import useWindowSize from "@/hook/useWindowSize";
import {Modal, DrawerUp} from "./mui";
import useMobileDetect from "next-device-detection";

interface Props {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export default function AppModal(props: any) {
  const detectMobile = useMobileDetect();
  if (detectMobile.isMobile) {
    return <DrawerUp {...props} anchor="bottom"/>;
  } else {
    return <Modal {...props} />;
  }
}
